import React from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { updateSearchType } from '../ActionsBrafab/FacetedSearch.action'

const SearchResult = () => {
    const dispatch = useDispatch();
    const searchTabs = useSelector((state) => state.searchTabs);
    const tabs = ['products', 'spareparts', 'inspiration', 'pages']

    const onTabClick = (tab) => {
        if (tab !== searchTabs.activeTabName)
        {            
            if (document.querySelector('.product-list') !== null) {
                document.querySelector('.product-list').classList.add('searching');
            }                
            dispatch(updateSearchType(tab))
        }
    }

    return (
        <div className="search-result">
            <div className="search-result__tabs">
                <div className="row">
                    <div className="columns">
                        <ul>
                            {tabs.map((tab) => (
                                <li
                                key={tab}
                                className={`search-result__tab ${
                                    searchTabs.activeTabName === tab ? 'active' : ''
                                }`}
                                onClick={() => onTabClick(tab)}
                            >
                                <span>
                                    {translate(`common.quicksearch.header.${tab}`)} (
                                    {searchTabs[tab + 'TotalCount']})
                                </span>
                            </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SearchResult;
